import type { RetryAttemptStore } from '@core/ports/RetryAttemptStore';

/** A temporary error allows the user exactly one manual retry until a step succeeds. */
export class RetryBudgetUseCase {
  public constructor(private readonly retryAttemptStore: RetryAttemptStore) {}

  public isRetryAvailable(): boolean {
    return !this.retryAttemptStore.hasUsedRetry();
  }

  public consumeRetry(): void {
    this.retryAttemptStore.markRetryUsed();
  }

  public restoreRetry(): void {
    this.retryAttemptStore.clearRetryUsed();
  }
}
